import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import "../../../styles/components/evs/modals/DriverAssociatedLicensePlates.scss"
import ListGroup from "react-bootstrap/ListGroup";
import Card from "react-bootstrap/Card";
import { Translate } from "react-redux-i18n";


class DriverAssociatedLicensePlates extends Component {
    constructor(props) {
        super(props);
        this._mounted = false;
        this.cancel = null;

        this.renderList = this.renderList.bind(this);
    }

    componentDidMount() {
        this._mounted = true;
    }

    componentWillUnmount() {
        this._mounted = false;
        if (this.cancel) this.cancel("Component is unmounting");
    }

    safeSetState(params, callback) {
        if (this._mounted) this.setState(params, callback);
    }

    renderList() {
        const { licensePlates = [] } = this.props;

        if (licensePlates.length === 0) {
            return (
              <ListGroup.Item>
                <Translate value="drivers_noLicensePlatesAssociated" />
              </ListGroup.Item>
            );
        }
        return licensePlates.map((d, idx) => <ListGroup.Item key={idx}>{d}</ListGroup.Item>);
    }

    render() {
            return (
                <Modal
                id="DriverAssociatedLicensePlates"
                show={this.props.show}
                onHide={this.props.onHide}
                centered
                >
                    <Modal.Header>
                        <Modal.Title>
                            <Translate value="drivers_associatedLicensePlateModalTitle"/>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Card>
                            <ListGroup
                            variant="flush"
                            style={{ overflowY: "auto", maxHeight: "30rem" }}
                            >
                                {this.renderList()}
                            </ListGroup>
                        </Card>
                    </Modal.Body>
                </Modal>
            );
        }
    }

    export default DriverAssociatedLicensePlates;
